import React, { Component } from 'react';

class TabDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <div className="analyze">我的流程</div>;
  }
}

export default TabDetail;



// WEBPACK FOOTER //
// ./src/components/flow/PageWatch.js